import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { stampCardSorterAtom, expandStoreStampIdAtom } from '../atoms/stampAtoms';

function useStampCards() {
  const sorter = useAtomValue(stampCardSorterAtom);
  const setShopId = useSetAtom(expandStoreStampIdAtom);
  const { pop } = useFlow();
  const toast = useToast();
  const { data, status } = useQuery(queries.stamps.cardList(sorter));
  useEffect(() => {
    if (status === 'error') {
      pop();
      toast.error('스탬프 카드 목록을 불러오는데 실패했습니다.');
    }
  }, [status]);
  useEffect(() => {
    if (data && data.length > 0) {
      setShopId(data[0].shopId);
    }
  }, [data]);
  return data;
}

export default useStampCards;
